import React, { useEffect, useState } from "react";
import { api, s3Url } from "../service/api.service";
import Footer from "../components/footer/footer";

const Wallpaper = () => {
  const [wallpaperData, setWallpaperData] = useState({ webFileUrls: [], mobileFileUrls: [] });
  const [activeTab, setActiveTab] = useState("desktop");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [previewImage, setPreviewImage] = useState("");

  useEffect(() => {
    const fetchWallpapers = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await api.get("/admin/wallpaper/images");
        const data = response?.data || response;
        const webFileUrls = data?.data?.webFileUrls || data?.webFileUrls || [];
        const mobileFileUrls = data?.data?.mobileFileUrls || data?.mobileFileUrls || [];
        setWallpaperData({ webFileUrls, mobileFileUrls });
      } catch (err) {
        setError("Unable to load wallpapers. Please try again later.");
        console.error("Wallpaper API error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchWallpapers();
  }, []);

  return (
    <div>
      <div className="py-24 bg-[#FFF5F3]">
        <div className="max-w-7xl mx-auto px-4">
          <h1
            className="text-5xl font-semibold text-center mb-6"
            style={{ fontFamily: "Philosopher, sans-serif" }}
          >
            {activeTab === "desktop" ? "Desktop Wallpaper" : "Mobile Wallpaper"}
          </h1>
          <p className="text-center text-gray-600 mb-10 max-w-2xl mx-auto">
            આજે જ ડાઉનલોડ કરો તમારા ફોન, ટેબ્લેટ, લેપટોપ અને કમ્પ્યુટર માટે લાડીલા  શ્રી ઘનશ્યામના નવા વોલપેપર.
          </p>

          <div className="flex justify-center gap-4 mb-10">
            <button
              type="button"
              onClick={() => setActiveTab("desktop")}
              className={`px-6 py-3 rounded-full font-semibold transition ${
                activeTab === "desktop"
                  ? "bg-primary text-white"
                  : "bg-white text-gray-700 border border-gray-200"
              }`}
            >
              Desktop Wallpaper
            </button>
            <button
              type="button"
              onClick={() => setActiveTab("mobile")}
              className={`px-6 py-3 rounded-full font-semibold transition ${
                activeTab === "mobile"
                  ? "bg-primary text-white"
                  : "bg-white text-gray-700 border border-gray-200"
              }`}
            >
              Mobile Wallpaper
            </button>
          </div>

          {loading ? (
            <div className="text-center text-lg text-gray-500">Loading...</div>
          ) : error ? (
            <div className="text-center text-red-600">{error}</div>
          ) : (activeTab === "desktop" ? wallpaperData.webFileUrls : wallpaperData.mobileFileUrls).length === 0 ? (
            <div className="text-center text-gray-500">No wallpapers found.</div>
          ) : (
            <div className={
      activeTab === "desktop"
        ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        : "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6"
    }>
              {(activeTab === "desktop" ? wallpaperData.webFileUrls : wallpaperData.mobileFileUrls).map((item, index) => {
                const relativePath = typeof item === "string" ? item : item?.url || item?.fileUrl || item?.image;
                const imageUrl = relativePath
                  ? relativePath.startsWith("http")
                    ? relativePath
                    : `${s3Url}${relativePath}`
                  : "";

                return (
                  <div
                    key={`wallpaper-${activeTab}-${index}-${relativePath?.substring(relativePath.lastIndexOf("/") + 1)}`}
                    className="overflow-hidden rounded-3xl bg-white shadow-sm border group"
                  >
                    <div className="relative overflow-hidden">
                      <img
                        src={imageUrl}
                        alt={`${activeTab}-wallpaper-${index}`}
                        className={
                activeTab === "desktop"
                  ? "w-full aspect-video object-cover transition duration-500 group-hover:scale-105"
                  : "w-full aspect-[9/16] object-cover transition duration-500 group-hover:scale-105"
              }
                      />
                      <div className="absolute inset-0 bg-black/0 transition duration-500 group-hover:bg-black/40"></div>
                      <div className="absolute inset-0 flex items-center justify-center gap-3 opacity-0 transition duration-500 group-hover:opacity-100">
                        <button
                          type="button"
                          onClick={() => setPreviewImage(imageUrl)}
                          className="mx-2 px-5 py-2 rounded-full bg-white text-gray-900 font-semibold shadow-md"
                        >
                          View
                        </button>
                        <a
                          href={imageUrl}
                          download
                          className="mx-2 px-5 py-2 rounded-full bg-primary text-white font-semibold shadow-md"
                        >
                          Download
                        </a>
                      </div>
                    </div>
                    {/* <div className="p-4">
                      <div className="text-sm text-gray-600 break-words truncate">
                        {relativePath?.substring(relativePath.lastIndexOf("/") + 1)}
                      </div>
                    </div> */}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      {previewImage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4">
          <div className="relative max-w-5xl w-full rounded-3xl overflow-hidden bg-white shadow-2xl">
            <button
              type="button"
              onClick={() => setPreviewImage("")}
              className="absolute right-4 top-4 z-10 rounded-full bg-black/70 px-4 py-2 text-white"
            >
              Close
            </button>
            <img
              src={previewImage}
              alt="Preview Wallpaper"
              className="w-full max-h-[85vh] object-contain bg-black"
            />
          </div>
        </div>
      )}
      <Footer />
        </div>
    </div>
  );
};

export default Wallpaper;
